import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { LogoutIcon, ProfileIcon, SettingIcon } from "app/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUser } from "store/global/authPermission/selector";
import { actions as authActions } from "../../../Auth/slice";
import { useStyles } from "./styles";

type Props = {
  q?: string;
  setSearch?(q: string): void;
};

export default function TopBar({ q, setSearch }: Props) {
  const user = useSelector(selectUser);
  const styles = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const handleLogout = () => {
    localStorage.clear();
    dispatch(authActions.logout());
    navigate("/auth/login");
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (setSearch) {
      setSearch(event.target.value);
    }
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <Box className={styles.root}>
        <Box className={styles.container}>
          <Box className={styles.leftSection}>
            <Tooltip title={t("TOOLTIP.OPEN_SETTINGS")}>
              <Box className={styles.userBox} onClick={handleOpenUserMenu}>
                <KeyboardArrowDownIcon className={styles.arrowIcon} />

                <Typography className={styles.userName}>
                  {user?.firstName || "גין סנטאג"}
                </Typography>

                <Avatar src={user?.url} className={styles.avatar}>
                  {user?.firstName?.charAt(0)?.toUpperCase() || "JS"}
                </Avatar>
              </Box>
            </Tooltip>

            <Box className={styles.notificationBox}>
              <NotificationsNoneIcon className={styles.notificationIcon} />
            </Box>
          </Box>

          <Box className={styles.rightSection}>
            <TextField
              className={styles.search}
              placeholder={t("PLACEHOLDERS.SEARCH")}
              size="small"
              value={q || ""}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: <SearchIcon className={styles.searchIcon} />,
              }}
            />
          </Box>
        </Box>
      </Box>

      <Menu
        className={styles.userMenu}
        PaperProps={{ className: styles.userMenuPaper }}
        MenuListProps={{
          autoFocusItem: false,
          className: styles.userMenuList,
        }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
        disableAutoFocusItem
        disableAutoFocus
        disableRestoreFocus
      >
        <MenuItem
          className={styles.userMenuItem}
          onClick={() => {
            navigate("/profile");
            handleCloseUserMenu();
          }}
        >
          <ProfileIcon className={styles.userMenuIcon} />
          <Typography className={styles.userMenuLabel}>
            {t("COMMON.PROFILE")}
          </Typography>
        </MenuItem>

        <MenuItem
          className={styles.userMenuItem}
          onClick={() => {
            handleCloseUserMenu();
          }}
        >
          <SettingIcon className={styles.userMenuIcon} />
          <Typography className={styles.userMenuLabel}>
            {t("COMMON.SETTINGS")}
          </Typography>
        </MenuItem>

        <Divider className={styles.userMenuDivider} />

        <MenuItem
          className={styles.userMenuItem}
          onClick={() => {
            handleCloseUserMenu();
            handleLogout();
          }}
        >
          <LogoutIcon className={styles.userMenuIcon} />
          <Typography className={styles.userMenuLabel}>
            {t("COMMON.LOG_OUT")}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
